import { Build, AccountBalanceWallet } from "@mui/icons-material";

/**
 * Profile menu options (like webapp: Configure Trend under profile, not in drawer).
 */
export const ProfileMenuOptions = [
  {
    id: "configureTrend",
    label: "Configure Trend",
    icon: Build,
    action: "configureTrend",
    page: "ConfigureTrend",
  },
  {
    id: "managePaperTrade",
    label: "Manage Paper Trade",
    icon: AccountBalanceWallet,
    action: "managePaperTrade",
    page: "ManagePaperTrade",
  },
];

export const getProfileMenuOptions = () => ProfileMenuOptions;
